//****Librarys ****//
import React, { useContext, useEffect, useState } from "react";
import { Dropdown, Stack, TextField } from "@fluentui/react";
import { RequestFetch } from "../../utils/Requests/requests.Controller";
import { useParams } from "react-router-dom";
import CookiesJS from "js-cookie";
import { getSafeCookie, getIdLanguage } from '../../helpers/cookieHelper';
import { useNavigate } from "react-router-dom";
//*****Componnents*****//
import HeaderForm from "../../components/Forms/headerForm/headerForm.component";

//*****File*****//
import { ReactComponent as IconData } from "../../assets/img/ico-datos.svg";
import ContainerBaseLoading from "../../components/containers/baseLoading/containerBaseLoading.component";
import LargeFormInput from "../../components/containers/largeForm/components/LargeFormInput";
import LenguajeContext from "../../context/Lenguaje/lenguajeContext";

//**Methods**//

/**
 *@author Sebastian Ocampo(02-08-2022)
 *@version 1.0
 *@lastCommit
 */
const DataUser = (props) => {
  /************************
   * @arguments
   ************************/
   
  const navigate = useNavigate();
  const requestsAttribute = new RequestFetch("Attribute/values");
  const requestsUser = new RequestFetch("Users");
  const { clientName } = useParams();
  const [buttonDisable, setButtonDisable] = useState(true)
  const dataUserSession = getSafeCookie('dataUser');
  const dataUserIdLng = getIdLanguage();
  const [arrayAttributes, setArrayAttributes] = useState([]);
  const [renderForm, setRenderForm] = useState([]);
  const [isDisable, setDisable] = React.useState([
    { disable: false, key: "valueDefault" },
    { disable: true, key: "name" },
  ]);
  const [controlsPage, setControlsPage] = useState({});
  const {getLenguaje, stateLanguage} = useContext(LenguajeContext);
  const [itemsComponentInformation, setItemsComponentInformation] = useState(
    []
  );
  const [defaultValueInput, seDefaultValueInput] = useState([]);
  const [defaultSelectedKeys, setDefaultSelectedKeys] = useState([]);
  const [idUser, setIdUSer] = useState(dataUserSession.user.id);
  const [idEditables, setIdEditables] = useState([])
  const [configuredAttributeValues, setConfiguredAttributeValues] = useState({});

  let listSchemasUser = [];

  //#region Constantes de accion para los componentes
  const actionOnChange = (data) => {
    
    if (data.selectedItem != "" && data.selectedItem != undefined && data.selectedItem != data.defaulvalue) {
        setButtonDisable(false)
    }
    else{
      setButtonDisable(true)
    }
    if (data.id === "listSchemasUser" && data.key !== undefined) {
      setRenderForm([]);
      setRenderForm(arrayAttributes[data.key]);
    }
  };

  const blackItem = (value, blackList) =>{
    let valid = true
    if (blackList.length > 0) {
      blackList.forEach((item) => {
         if (item == value){
           valid = false
        }
      })
    }
    return valid
  }
  const onSubmitEventFormPanel = (data) => {
    data.preventDefault();
    let dataFormSubmit = [];
    let acceptTermsConditions = false;
    for (let entry of data.target) {
      if (entry.localName === "input" && entry.type !== "checkbox" 
      && !entry.id.startsWith("configured-") && blackItem(entry.id,idEditables)) {
        dataFormSubmit.push({
          op: "replace",
          path: entry.id,
          value: entry.value,
        });
      }
      if (entry.type === "checkbox") {
        acceptTermsConditions = entry.checked;
      }
    }
    
    arrayAttributes.filter((attribute) => attribute.configuration).forEach((attribute) => {
      const values = getConfiguredAttributeValues(attribute);
      const requiredCompleted = attribute.configuration.parameters
        .filter((parameter) => parameter.required)
        .every((parameter) => values[parameter.key]);

      if (!requiredCompleted) { return; }

      const newValue = buildConfiguredAttributeValue(attribute.configuration, values);

      if (newValue === attribute.value) { return; }

      dataFormSubmit.push({
        op: "replace",
        path: attribute.attribute,
        value: newValue,
      });
    });
     
      if (dataFormSubmit.length === 0) {
        setButtonDisable(true);
        return;
      }

    requestsUser.confirmRequest({
      body: dataFormSubmit,
      id: idUser,
      ct: "application/json-patch+json",
      tenant: clientName,
      option: "patchItem",
      acceptTermsConditions: acceptTermsConditions,
      op:'b',
      headerEx: {idLanguageUser:dataUserIdLng?dataUserIdLng:dataUserSession.user.idLanguage},
      infoModal:{
        title:controlsPage?.lblSuccessfulProcess?.value,
        description:controlsPage?.lblTheInformationHBeenRegisteredCorrectly?.value
      }
    });
  };
  
  useEffect(() => {
    const footerStyle = document.querySelector('.admin--container-footer');
    footerStyle?.classList.add('div-foot-in');
    props.onChange('div-foot-in')
  }, [props])

  const typeInput = (data) =>{
    let inpType = ''

    if (data.isEmail) {
      inpType='email'
    }

    if (data.isPhone) {
      inpType='text'
    }
    return inpType

  }


  useEffect(async() => {
    let controlsPage = {};
    if (stateLanguage.lenguaje !=0) {
        stateLanguage.lenguaje.map((pass) => {
            if (pass.path == 'query-update-data' || pass.path == 'controls')  {
              pass.webcontrolspages.map((data) => {
                controlsPage[data.idHtml] = data.languagewebcontrols[0];
              })  
            }              
        })          
      setControlsPage(controlsPage)
    }
  }, [stateLanguage])
  const actionOnClick = (data) => {};
  //#endregion
  /************************
   * @methods
   ************************/
  //#region Consultar el id del usuario
  const [promiseAuthenticationFactor, setPromiseAuthenticationFactor] =
    useState();

  useEffect(async() => {
    let arrayTemporary = [];
    let idsBlack = []
    if (arrayAttributes.length>0) {
      window.location.reload()
    }
    const form = await requestsAttribute.getItem({ tenant: clientName, headerEx: {idLanguageUser:dataUserIdLng?dataUserIdLng:dataUserSession.user.idLanguage}})
    form.data.data.map(idEdit=>{
    if (!idEdit.isEditable) {
        idsBlack.push(idEdit.id)
      }
    })
    setIdEditables(idsBlack)

    form.data.data.map(inp =>{
      inp = {...inp,...{typeInput:typeInput(inp)}}
      arrayTemporary.push(
        inp
      )
      setArrayAttributes([...arrayAttributes,...arrayTemporary]);
    })
  
  }, [CookiesJS.get("dataUser"),])
  

  

  //#endregion

  /************************
   * @hooks
   ************************/

  /************************
   * @resturns
   ************************/
  if (arrayAttributes.length === 0 || Object.entries(controlsPage).length === 0) {
    return <ContainerBaseLoading />;
  }

  // ***** Funciones para atributos que tengan "Configuration"

  const getConfiguredAttributeKey = (attribute) => {
    return `${attribute.atribute}-${attribute.attribute}`;
  };

  const buildConfiguredAttributeValue = (configuration, values) => {
    let result = configuration.template;

    configuration.parameters.forEach((parameter) => {
      result = result.replace(`{${parameter.key}}`, values[parameter.key] || "");
    });

    return result;
  };

  const parseConfiguredAttributeValue = (attribute) => {
    const configuration = attribute.configuration;
    const currentValue = attribute?.value?.trim() || "";
    const values = {};

    if (!currentValue || !configuration?.template || !configuration?.parameters?.length) {
      return values;
    }

    let pattern = configuration.template.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

    configuration.parameters.forEach((parameter) => {
      pattern = pattern.replace(`\\{${parameter.key}\\}`, "(.*?)");
    });

    const match = currentValue.match(new RegExp(`^${pattern}$`));

    configuration.parameters.forEach((parameter, index) => {
      values[parameter.key] = match ? match[index + 1] : "";
    });

    return values;
  };

  const getConfiguredAttributeValues = (attribute) => {
    const attributeKey = getConfiguredAttributeKey(attribute);

    return configuredAttributeValues[attributeKey] ||
      parseConfiguredAttributeValue(attribute);
  };

  const getParameterOptions = (parameter) => {
    if (parameter.options?.length) {
      return parameter.options.map((option) => ({
        key: option.value,
        text: option.text,
      }));
    }

    const minimum = parameter.range?.minimum;
    const maximum = parameter.range?.maximum;

    if (!Number.isInteger(minimum) || !Number.isInteger(maximum) || minimum > maximum) {
      return [];
    }

    return Array.from({ length: maximum - minimum + 1 }, (_, index) => {
      const value = String(minimum + index);

      return {
        key: value,
        text: value,
      };
    });
  };

  const updateConfiguredAttribute = (attribute, parameterKey, value) => {
    const currentValues = getConfiguredAttributeValues(attribute);
    const updatedValues = {
      ...currentValues,
      [parameterKey]: value,
    };
    const attributeKey = getConfiguredAttributeKey(attribute);

    setConfiguredAttributeValues((previousValues) => ({
      ...previousValues,
      [attributeKey]: updatedValues,
    }));

    const requiredCompleted = attribute.configuration.parameters
      .filter((parameter) => parameter.required)
      .every((parameter) => updatedValues[parameter.key]);

    if (!requiredCompleted) {
      setButtonDisable(true);
      return;
    }

    const newValue = buildConfiguredAttributeValue(attribute.configuration, updatedValues);

    setButtonDisable(newValue === attribute.value);
  };

  // ***** FIN Funciones para atributos que tengan "Configuration"

  return (
    <>
      <HeaderForm
        iconurl={<IconData fill="var(--color-primary)" className="claso"/>}
        title={controlsPage?.lblUserData.value}
        subtitle={controlsPage?.lblProfileData.value}
      />

      <form
        className="c--flex-wse w10"
        onSubmit={(e) => onSubmitEventFormPanel(e)}
        style={{marginBottom:'10%'}}
      >
        <div className="prueb">
          <div className={props.isAdmin?"scrollUserAdmin":"scrollUserFinal"}>

        { arrayAttributes.map(inp=>{
          const configuration = inp.configuration;

          if (configuration?.template && configuration?.parameters?.length > 0) {
            const configuredValues = getConfiguredAttributeValues(inp);

            return (
              <div key={`${inp.atribute}-${inp.attribute}`}
                className="w10 fl w10-resp">
                  
                <div className="ms-Label">{inp.attribute}</div>
                <div className="w10">
                  {configuration.parameters.map((parameter) => {
                    if (parameter.type === "dropdown") {
                      return (
                        <div
                          key={parameter.key}
                          className={props.isAdmin ? "w45 fl w9-resp" : "w5 fl w10-resp"}
                        >
                          <Dropdown
                            id={`configured-${parameter.key}-${inp.atribute}-${inp.id}`}
                            label={parameter.label}
                            placeholder={parameter.placeholder}
                            options={getParameterOptions(parameter)}
                            selectedKey={configuredValues[parameter.key] || undefined}
                            onChange={(_, option) =>
                              updateConfiguredAttribute(
                                inp,
                                parameter.key,
                                option ? String(option.key) : ""
                              )
                            }
                            required={parameter.required}
                            disabled={!inp.isEditable}
                            styles={{ root: { width: "100%" } }}
                          />
                        </div>
                      );
                    }

                    if (parameter.type === "inputText") {
                      return (
                        <div
                          key={parameter.key}
                          className={props.isAdmin ? "w45 fl w9-resp" : "w5 fl w10-resp"}
                        >
                          <TextField
                            id={`configured-${parameter.key}-${inp.atribute}-${inp.id}`}
                            label={parameter.label}
                            placeholder={parameter.placeholder}
                            value={configuredValues[parameter.key] || ""}
                            maxLength={parameter.maxLength}
                            required={parameter.required}
                            disabled={!inp.isEditable}
                            onChange={(_, value) =>
                              updateConfiguredAttribute(inp, parameter.key, value || "")
                            }
                            styles={{ root: { width: "100%" } }}
                          />
                        </div>
                      );
                    }

                    return null;
                  })}
                </div>
              </div>
            );
          }
          return(
            <LargeFormInput
              item={{
                id: inp.attribute,
                key: inp.attribute,
                label: inp.attribute,
                ariaLabel: null,
                defaultValu: inp.value
                  ? inp.value
                  : "",
                  defaultValue: inp.value
                  ? inp.value
                  : "",
                disabled: true,
                disable:!inp.isEditable,
                resizable: false,
                typeInput: inp.typeInput,
                description: "",
                title: null,
                onRenderLabel: null,
                isRequired: false,
                onGetErrorMessage: null,
                errorMsg:true,
                className:props.isAdmin?'w45 fl w9-resp':'w5 fl w10-resp'
              }}
              actionOnChange={actionOnChange}
              actionOnClick={actionOnClick}
              isDisableOpt={isDisable}
              onSubmitEventFormPanel={onSubmitEventFormPanel}
              itemsComponentInformation={itemsComponentInformation}
              defaultValueInput={defaultValueInput}
              defaultSelectedKeys={defaultSelectedKeys}
            />
          )
        })
      }
          </div>
          </div>
        <Stack
          style={{
            width: "70%",
            "margin-left": "auto",
            "margin-right": "auto",
            "padding-bottom": "1rem",
            "padding-top": "1rem",
          }}
        >
          
        </Stack>
        <Stack
          style={{
            width: "20%",
            marginLeft: "auto",
            marginRight: "42%",
          }}
        >
          <button
            type="submit"
            className={`button--default-pass ${buttonDisable?'button--disable':'button--primary'}`}
            disabled={buttonDisable}
          >
            {controlsPage?.smtSave.value}
          </button>
        </Stack>
      </form>
    </>
  );
};

export default DataUser;
